import { Fun } from 'widgets-for-react'

import { CtaBlockStyle } from '../../cms/blocks/widgets/ctaBlock.gen'
import { DownloadBlockStyle } from '../../cms/blocks/widgets/downloadBlock.gen'
// import { ExpandBlockStyle } from '../../cms/blocks/widgets/expandBlock.gen'
import { FeaturedContentBlockStyle } from '../../cms/blocks/widgets/featuredContentBlock.gen'
import { LinkBlockStyle } from '../../cms/blocks/widgets/linkBlock.gen'
import { LinkGridBlockStyle } from '../../cms/blocks/widgets/linkGridBlock.gen'
import { TextBlockStyle } from '../../cms/blocks/widgets/textBlock.gen'
import { ExpandBlockStyle } from '../../cms/blocks/widgets/expandBlock.gen'
import { MediaBlockStyle } from './custom_blocks/widgets/mediaBlock'
import { IframeBlockStyle } from './custom_blocks/widgets/iframeBlock'
import { QuoteBlockStyle } from './custom_blocks/widgets/quoteBlock'
import { HeaderBlockStyle } from './custom_blocks/widgets/headerBlock.mod'
import { FormBlockStyle } from './custom_blocks/widgets/formBlock.mod'
import { CarouselBlockStyle } from './custom_blocks/widgets/carouselBlock'

export const featuredContentClasses: Fun<'left' | 'right', FeaturedContentBlockStyle> = m => ({})

export const headerBlockClasses:HeaderBlockStyle = {
    block_classname: 'aa',
    inner_classname: 'bb',
    header_classname: 'cc',
    title_classname: 'dd',
    content_classname: 'ee',
    intro_classname: 'ff',
    visual_classname: 'gg'
}

export const textBlockClasses:TextBlockStyle = {
    block_classname: 'block block--text',
    inner_classname: 'block__inner',
    clickable_primary_classname: 'button button--primary',
    clickable_secondary_classname: 'button button--secondary',
    header_classname: 'block--text__header',
    content_classname: 'block--text__content',
    footer_classname: 'block--text__footer',
    text_classname: 'block--text__text text--styled',
    title_classname: 'block--text__title'
}

export const ctaBlockClasses: CtaBlockStyle = {
    block_classname: 'block block--cta',
    inner_classname: 'block__inner container--l grid--block',
    header_classname: 'block__header',
    title_classname: 'block__title typo--4xl',
    content_classname: 'block__content text--styled',
    text_classname: 'block__text typo--xs',
    footer_classname: 'block__footer',
    clickable_primary_classname: 'button button--secondary',
    clickable_secondary_classname: 'button button--secondary'
}

export const linkListBlockClasses: LinkBlockStyle = {
    block_classname: 'block block--link-list',
    inner_classname: 'block__inner',
    header_classname: 'block--link-list__header',
    title_classname: 'block--link-list__title',
    intro_classname: 'block--link-list__intro',
    content_classname: 'block--link-list__content',
    list_classname: 'link-list',
    item_classname: 'link-list__item',
    link_classname: 'link-list__link'
}

export const downloadBlockClasses: DownloadBlockStyle = {
    block_classname: 'block block--download',
    inner_classname: 'block__inner',
    header_classname: 'block--download__header',
    title_classname: 'block--download__title',
    intro_classname: 'block--download__intro',
    content_classname: 'block--download__content',
    list_classname: 'download-list',
    item_classname: 'download-list__item',
    link_classname: 'download-list__link'
}

export const formBlockClasses: FormBlockStyle = {
    block_classname: 'block block--form',
    inner_classname: 'block__inner',
    content_classname: 'block__content'
}

export const tableBlockClasses: FormBlockStyle = {
    block_classname: 'block block--table',
    inner_classname: 'block__inner',
    content_classname: 'table-outer'
}


export const linkGridBlockClasses: Fun<boolean, LinkGridBlockStyle> = hasbutton => ({})

export const expandBlockClasses: ExpandBlockStyle = {
    block_classname: 'block block--expand',
    inner_classname: 'block__inner',
    header_classname: 'block--expand__header',
    title_classname: 'block--expand__title',
    intro_classname: 'block--expand__intro',
    content_classname: 'block--expand__content',
    text_classname: 'block--expand__text',
    footer_classname: 'block--expand__footer',
    clickable_classname: 'block--expand__clickable',
    list_classname: 'expand-list',
    expand_item_classname: 'expand-list__item',
    expand_button_classname: 'expand__button',
    expand_title_classname: 'expand__title',
    expand_icon_classname: 'expand__icon',
    expand_text_classname: 'expand__text text--styled'
}

export const mediaBlockClasses : MediaBlockStyle = {
    block_classname: `block block--media`,
    inner_classname: `block__inner`,
    content_classname: 'section__content',
    // figure_classname: `block--media__visual`,
    media_classname: `block--media__image image--rounded`,
    image_classname: 'block--media__image image--rounded',
    placeholder_classname: 'section__media-placeholder',
    video_classname: '',
    figcaption_classname: 'block--media__visual-caption',
    caption_classname: '',
    cookies_classname: '',
    cookies_inner_classname: '',
    cookies_text_classname: '',
    cookies_clickable_classname: ''
}

export const linkGridBlockPlainClasses: Fun<number, LinkGridBlockStyle> = n => ({})

export const quoteBlockClasses : QuoteBlockStyle = {
    block_classname: 'block block--quote',
    inner_classname: 'block__inner',
    content_classname: 'block--quote__content',
    // text_classname: 'block--quote__text',
    quote_classname: 'block--quote__quote',
    visual_classname: 'block--quote__visual',
    image_classname: 'block--quote__image',
    author_classname: 'block--quote__author',
    footer_classname: 'block--quote__footer',
    clickable_classname: 'button button--primary'
}

export const iframeBlockClasses: IframeBlockStyle = {
    block_classname: 'block block--iframe',
    inner_classname: 'block__inner',
    content_classname: 'block__content',
    iframe_classname: 'block__iframe'
}

export const carouseBlockClasses: CarouselBlockStyle = {
  block_classname: "block block--carousel-image block--relief block--4-8",
  inner_classname: "block__inner grid--spacing",
  header_classname: "block__header grid--gutter",
  label_classname: "block__label space--s label--m",
  title_classname: "block__title typo--l",
  content_classname: "block__content",
  carousel_classname: "carousel",
  carousel_inner_classname: "carousel__inner",
  carousel_list_classname: "carousel__list",
  carousel_item_classname: "carousel__item",
  carousel_figure_classname: "carousel__figure",
  carousel_image_classname: "carousel__image lazyload",
  footer_classname:"block__footer grid--gutter"
}
